import type { FAQItem } from "@/types";

export const homeFaqs: FAQItem[] = [
  {
    question: "How much can I save by installing solar panels?",
    answer:
      "Savings vary based on your energy consumption, roof orientation, and the size of your system. Most of our residential customers see their energy bills drop by 50-80% immediately after installation, with the system paying for itself in 3-5 years.",
  },
  {
    question: "Do I need a battery with my solar system?",
    answer:
      "While a battery isn't strictly necessary, it allows you to store excess energy generated during the day for use at night or during power outages. This maximizes your self-consumption and provides energy independence. We can design a system that starts without a battery but is 'battery-ready' for future upgrades.",
  },
  {
    question: "How long does the installation process take?",
    answer:
      "The physical installation typically takes 1-2 days for residential systems and 1-2 weeks for commercial systems. However, the entire process from consultation, system design, grid connection approvals, to final commissioning usually takes 4-6 weeks.",
  },
  {
    question: "What maintenance do solar panels require?",
    answer:
      "Solar systems require very little maintenance. We recommend a professional clean and electrical safety check every 1-2 years to ensure optimal performance. Our systems include advanced monitoring apps so you can track performance and we can remotely diagnose any issues.",
  },
  {
    question: "Are there any government rebates available?",
    answer:
      "Yes! The Australian Federal Government provides STCs (Small-scale Technology Certificates) which act as an upfront discount on your system. Depending on your state, there may also be additional state-specific rebates or interest-free loans available. Our team handles all the rebate paperwork for you.",
  },
];
